import { readCustomerValue } from 'shared/field-display';
export function getter(obj, keys) {
  // For flattened fields
  if (keys.length > 1 && obj != null) {
    const flattenedKey = keys.join('__');
    if (flattenedKey in obj) {
      const value = obj[flattenedKey];
      if (value === null) {
        return null;
      }
      return typeof value === 'object' ? JSON.stringify(value) : value;
    }
  }

  // Original nested property access
  for (var i = 0; i < keys.length; i++) {
    if (obj == null) return null;
    obj = obj[keys[i]];
  }
  if (typeof obj === 'object' && obj !== null) {
    return JSON.stringify(obj);
  }
  return obj;
}

/**
 * A customer's raw value for one Customer data field (CIN-7177), for the Summary tab's chip rows and
 * the pinned chips under the name, so both read the same thing. Raw, not formatted: see
 * readCustomerValue in shared/field-display.js.
 */
export function getCustomerFieldValue(customer, field) {
  return readCustomerValue(customer, field?.id);
}